import React from "react";
import { Button, DatePicker, Space } from "antd";
import dayjs from "dayjs";
import { Locale } from "../../../utils";

const i18n = Locale.getInstance();

const PRESETS = [
  { key: 7, days: 7 },
  { key: 30, days: 30 },
  { key: 90, days: 90 },
];

export default function StatisticsDateFilter({ value, onChange, onApply, loading }) {
  const applyPreset = (days) => {
    const end = dayjs().startOf("day");
    const start = end.subtract(days - 1, "day");
    onChange([start, end]);
  };

  return (
    <div className="statistics-page__filters">
      <Space wrap>
        {PRESETS.map((preset) => (
          <Button
            key={preset.key}
            size="small"
            onClick={() => applyPreset(preset.days)}
          >
            {i18n.t(`statisticsCommon.preset${preset.key}`)}
          </Button>
        ))}
        <DatePicker.RangePicker
          value={value}
          format="YYYY-MM-DD"
          allowClear={false}
          onChange={(dates) => {
            if (dates && dates[0] && dates[1]) {
              onChange(dates);
            }
          }}
        />
        {onApply ? (
          <Button type="primary" loading={loading} onClick={onApply}>
            {i18n.t("statisticsCommon.apply")}
          </Button>
        ) : null}
      </Space>
    </div>
  );
}
